module.exports = __webpack_public_path__ + "img/plane.06d970fc.png";